module.exports = __webpack_public_path__ + "static/dianneicon-80717cc5687abb8183092147e2e3385f.png";